/* =============================================
   TP — Lightbox de imagem (tela cheia)

   Abre por DELEGAÇÃO no document, então cobre também as fotos injetadas depois
   (pop-up de compra rápida dos cards, do "combina com", do "compre o look",
   modal do kit) além das que já vêm no HTML (seção "Modelos vestem" da PDP).

   Alvos: .tp-qb__mv-img · .tp-mv__img · qualquer elemento com [data-tp-zoom]
   ============================================= */
(function () {
  if (window.__tpLightbox) return;
  window.__tpLightbox = true;

  var TARGETS = '.tp-qb__mv-img, .tp-mv__img, [data-tp-zoom]';
  var el = null;
  var imgEl = null;
  var lastFocus = null;

  // Pede uma versão maior da mesma imagem no CDN da Shopify (o thumb costuma
  // vir em 520–800px, pequeno demais para tela cheia).
  function hiRes(src) {
    if (!src) return src;
    if (src.indexOf('width=') !== -1) return src.replace(/width=\d+/, 'width=1800');
    if (src.indexOf('cdn.shopify.com') === -1) return src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=1800';
  }

  function build() {
    el = document.createElement('div');
    el.className = 'tp-lb';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Foto ampliada');
    el.hidden = true;
    // O X fica dentro de um "frame" que encolhe até o tamanho real da foto,
    // então ele acompanha o canto da imagem em vez do canto da tela.
    el.innerHTML =
      '<div class="tp-lb__frame">' +
      '<button type="button" class="tp-lb__close">' +
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>' +
      '</svg>' +
      '<span class="tp-lb__close-label">Fechar</span>' +
      '</button>' +
      '<img class="tp-lb__img" alt="">' +
      '</div>';
    document.body.appendChild(el);
    imgEl = el.querySelector('.tp-lb__img');

    // Fecha ao clicar no fundo ou no X (não ao clicar na própria foto)
    el.addEventListener('click', function (e) {
      if (e.target === imgEl) return;
      close();
    });
  }

  function open(src, alt) {
    if (!el) build();
    lastFocus = document.activeElement;
    imgEl.src = hiRes(src);
    imgEl.alt = alt || '';
    el.hidden = false;
    document.body.classList.add('tp-lb-open');
    void el.offsetWidth; // força reflow para a transição rodar
    el.classList.add('is-open');
    var closeBtn = el.querySelector('.tp-lb__close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    document.body.classList.remove('tp-lb-open');
    setTimeout(function () {
      el.hidden = true;
      imgEl.removeAttribute('src');
    }, 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var target = e.target.closest(TARGETS);
    if (!target) return;
    // não abre em placeholder (span sem imagem)
    if (target.tagName !== 'IMG' && !target.querySelector('img')) return;

    var img = target.tagName === 'IMG' ? target : target.querySelector('img');
    if (!img) return;

    // impede que o clique navegue (a foto pode estar dentro de um link)
    e.preventDefault();
    e.stopPropagation();
    open(img.currentSrc || img.src, img.alt);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') close();
  });
})();
